import { Stack } from "@mui/material";
import ExpenseDashBoardDesktop from "../components/desktop/expense-dashboard/ExpenseDashBoardDesktop";

const ExpenseDashBoard = () => {
  return (
    <Stack gap={2} m={2}>
      <ExpenseDashBoardDesktop />
    </Stack>
  );
};

export default ExpenseDashBoard;
